<template>
  <div v-frag>
    <b-row>
      <b-colxx xxs="12">
        <piaf-breadcrumb :heading="$t('menu.edit')" />
        <div class="separator mb-5"></div>
      </b-colxx>
    </b-row>

    <div v-if="isLoading" class="loading-overlay">
      <div class="loading"></div>
    </div>
    <b-row>
      <b-colxx xxs="12">
        <b-card class="mb-4">
          <b-form @submit.prevent="onSubmit" class="av-tooltip">
            <b-form-group :label="$t('pages.pages.selectImage')">
              <b-form-file
                v-model="editForm.image"
                accept="image/*"
                @change="imageUploaded = !imageUploaded"
              ></b-form-file>
            </b-form-group>

            <div class="my-2 mb-4">
              <img
                v-if="!imageUploaded && imageUrl !== null"
                :src="`${apiUrl}${imageUrl}`"
                class="object-cover"
                draggable="false"
                width="100"
                height="100"
                alt=""
              />
            </div>

            <b-form-group :label="`${$t('pages.pages.title')} (EN)`">
              <b-form-input type="text" v-model="$v.editForm.title_en.$model" :state="!$v.editForm.title_en.$error" />
              <b-form-invalid-feedback v-if="!$v.editForm.title_en.required">
                {{ $t('formErrors.enterTitle') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="`${$t('pages.pages.title')} (RU)`">
              <b-form-input type="text" v-model="$v.editForm.title_ru.$model" :state="!$v.editForm.title_ru.$error" />
              <b-form-invalid-feedback v-if="!$v.editForm.title_ru.required">
                {{ $t('formErrors.enterTitle') }}
              </b-form-invalid-feedback>
            </b-form-group>

            <b-form-group :label="`${$t('pages.pages.content')} (EN)`">
              <editor
                api-key="3j0ilbli3cyi4ni7rl6bja496o1axgmnbofy3zc9fdbbm8i2"
                v-model="editForm.content_en"
                :disabled="false"
                :init="{
                  height: 400,
                  menubar: true,
                  plugins: [
                    'advlist autolink lists code table link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount'
                  ],
                  toolbar:
                    'undo redo | code | table | formatselect | bold italic backcolor | \
                           alignleft aligncenter alignright alignjustify | \
                           bullist numlist outdent indent | removeformat'
                }"
              />
            </b-form-group>

            <b-form-group :label="`${$t('pages.pages.content')} (RU)`">
              <editor
                api-key="3j0ilbli3cyi4ni7rl6bja496o1axgmnbofy3zc9fdbbm8i2"
                v-model="editForm.content_ru"
                :disabled="false"
                :init="{
                  height: 400,
                  menubar: true,
                  plugins: [
                    'advlist autolink lists code table link image charmap print preview anchor',
                    'searchreplace visualblocks code fullscreen',
                    'insertdatetime media table paste code help wordcount'
                  ],
                  toolbar:
                    'undo redo | code | table | formatselect | bold italic backcolor | \
                           alignleft aligncenter alignright alignjustify | \
                           bullist numlist outdent indent | removeformat'
                }"
              />
            </b-form-group>

            <b-button type="submit" variant="primary" class="mt-2">
              {{ $t('buttons.save') }}
            </b-button>
          </b-form>
        </b-card>
      </b-colxx>
    </b-row>
  </div>
</template>

<script>
import Editor from '@tinymce/tinymce-vue'
import { apiUrl } from '@/constants/config'
const { required } = require('vuelidate/lib/validators')

export default {
  components: {
    editor: Editor
  },
  data: () => ({
    apiUrl,
    isLoading: true,
    imageUrl: null,
    imageUploaded: false,
    editForm: {
      title_en: '',
      title_ru: '',
      content_en: '',
      content_ru: '',
      image: null
    }
  }),
  validations: {
    editForm: {
      title_en: { required },
      title_ru: { required }
    }
  },
  mounted() {
    this.fetchSinglePage()
  },
  beforeDestroy() {
    this.clearForm()
  },
  methods: {
    fetchSinglePage() {
      this.$store.dispatch('pages/fetchSinglePage', {
        id: this.$route.params.id,
        vm: this
      })
    },
    addNotification(type, title, message) {
      this.$notify(type, title, message, { duration: 2000, permanent: false })
    },
    onSubmit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        const payload = {
          title_en: this.editForm.title_en,
          title_ru: this.editForm.title_ru,
          content_en: this.editForm.content_en,
          content_ru: this.editForm.content_ru
        }
        if (this.editForm.image) {
          payload.image = this.editForm.image
        }

        this.$store.dispatch('pages/updateSinglePage', {
          payload,
          id: this.$route.params.id,
          vm: this
        })
      }
    },
    clearForm() {
      this.editForm.title_en = ''
      this.editForm.title_ru = ''
      this.editForm.content_en = ''
      this.editForm.content_ru = ''
    }
  }
}
</script>
